import {getCohortsDB, getUser_Cohorts} from "../../../../services/api/get";
import React, {Fragment, useEffect, useState} from "react";
import {bindActionCreators} from "redux";
import * as Actions from "../../../../actions";
import * as StudyActions from "../../../dashboard/reducers/study_actions";
import * as SampleActions from "../analysis-page/reducers/sample_actions";
import {connect} from "react-redux";
import Typography from "@mui/material/Typography"; // Updated import
import {GPAP_Button, GPAP_Button_Light} from "../../../../gpap-lib/components/Button_Collection";
import Select from "react-select";
import Grid from "@mui/material/Grid"; // Updated import
import Box from "@mui/material/Box"; // Updated import
import Divider from "@mui/material/Divider"; // Updated import
import GPAP_Tooltip from "../../../../gpap-lib/components/GPAP_Tooltip";
import {Card, CardActions, CardMedia, CircularProgress, Paper} from "@mui/material"; // Updated imports
import CardContent from "@mui/material/CardContent"; // Updated import
import COHORTAPP_LOGO from "./cohortapp-icon.svg";
import {RefreshOutlined} from "@mui/icons-material"; // Updated import
import IconButton from "@mui/material/IconButton"; // Updated import
import {Alert, AlertTitle} from "@mui/material"; // Updated import
import InfoIcon from "@mui/icons-material/Info"; // Updated import
import { change } from "redux-form";
import SelectedCohortMessage from "./SelectedCohortMessage";

function CohortSelect(props){


    const [cohorts, setCohorts] = useState(false);
    const [selected, setCohortSelected] = useState(false);
    const [cohortJson, setCohortJson] = useState(false);
    const [initialized, setInitialized] = useState(false);
    const [created, setCreated] = useState(false);
    const [loading, setLoading]  = useState(false);
    const [URL_CohortID, setURLCohortID]  = useState(false);
    let {api_phenostore, api_cohortapp} = config.apis_configuration;


    useEffect(function(){

        let mounted = true;

        if(!cohorts){
            setLoading(true);
            collectCohorts();

            return function cleanup() {
                mounted = false
            }
        }



    });

    const collectCohorts = () => {

        let mounted = true;

        getUser_Cohorts(api_cohortapp, props.token)
            .then((response) =>
                response.json())
            .then((json) =>  {
                if(mounted){
                    setCohorts(json.data);
                    if(props.cohort_id_from_url){

                        let find= json.data.find(s => s.id === props.cohort_id_from_url);
                        if(find!== undefined){
                            setURLCohortID(props.cohort_id_from_url);
                            setCohortJson(find);  
                            let obj = {value: find.cohortName, label: find.cohortName};
                            setCohortSelected(obj);
                        }
                    }

                    setTimeout( () => setLoading(false),1000);
                }
            });
    }


    const loadCohorts = () => {

        setLoading(true);
        setCohortSelected(false);
        setCohorts([]);
        collectCohorts();


    }

    const handleSelectCohort = (value) => {

        let cohort = cohorts.find(s => s.cohortName === value.value);
    
        setCohortJson(cohort);  
        setCohortSelected(value);

    };


    const renderCohortView = () => {

        let options = [];
        if(Array.isArray(cohorts)){
           options =  cohorts.map(s => {
                let name = s.cohortName + " (" + s.data.length + " experiments )";
                return {value: s.cohortName, label:  name }});
            // cohorts list;


        }


        if (selected) {
            return null 
        } 
        else{
            return <Fragment>
            <div style={{    width: "100%",display: "block", height: "30px"}}>
                <div style={{float: "left", width: "100%"}}>
                    <IconButton style={{float: "right"}} onClick={() => loadCohorts()}>
                        <RefreshOutlined/>
                    </IconButton>
                </div>
            </div>
            <Box p={1}>
                <Typography variant={"h6"} >Cohorts ready for analysis</Typography>
                {
                    (loading)
                        ? <Box style={{textAlign: "center"}}><CircularProgress/></Box>
                        : <Select options={options}
                                  isSearchable={true}
                                  onChange = {(value) => handleSelectCohort(value)}/>

                }
        </Box>
        </Fragment>
        }
        
    };

    const createStudyCohort = () =>{

        if(selected){

            let cohort = cohorts.find(s => s.cohortName === selected.value);
            setCohortJson(cohort);  
            props.assignAnalysis(cohort)
            setCreated(true);
            setInitialized(true);
            // add cohort to redux;
              
            props.actions.set_selected_cohort(cohort.id);
        }

    };

    const renderCohortCard = () => {

        return <Fragment>
            <Divider/>
            <Box p={1}>
                <Typography gutterBottom variant="h6" component="div">
                    Create a cohort to analyse
                </Typography>
            </Box>

            <Card elevation={2}>
                <CardMedia
                    style={{background: "#4575B4"}}
                    component="img"
                    height="140"
                    image= {COHORTAPP_LOGO}
                    alt="cohort_app"
                />
                <CardContent>
                </CardContent>
                <CardActions>
                    <GPAP_Tooltip title={"Click here if you still need to create a cohort to analyze"}>
                        <GPAP_Button
                            target={"_blank"}
                            href={window.location.origin + "/cohortapp/#/dashboard"}
                        >Create a Cohort
                        </GPAP_Button>
                    </GPAP_Tooltip>
                </CardActions>
            </Card>
        </Fragment>

    }


    const isStudyCreated = () => {


        if(created){
            return <Grid item lg={7}>
            <Box p={0}>
                <Typography variant={"subtitle1"} >Study created, click on Next to select variant and gene filters</Typography>
            </Box>
        </Grid>
        }
       

    }

    const changeCohort = () => {

        setCohortSelected(false);

    }


    const CohortSelected = () => {


        return  (selected) ? <Grid item lg={12}>

                <SelectedCohortMessage selected={selected} 
                                       cohortObj = {cohortJson} 
                                       createStudyCohort={createStudyCohort} 
                                       changeCohort={changeCohort}/>
            
                </Grid>
                : null
        
    }


    return (
        <Grid container direction="column" alignItems="left" spacing={3}>
          {/* Title and Description */}
          <Grid item xs={12} lg={7}>
            <Box textAlign="left">
              <Typography variant="h5">Select a cohort</Typography>
              <Typography variant="body1" color="textSecondary">
                Analyze cohorts by creating them in the GPAP CohortApp. Saved cohorts will populate the list below for selection.
              </Typography>
            </Box>
          </Grid>
    
          {/* Cohort Selection/Display */}
          <Grid item xs={12} lg={7}>
            <Box>
              {CohortSelected()}
            </Box>
          </Grid>
    
          {/* Cohort View */}
          <Grid item xs={12} lg={8}>
            <Box p={2}>
              {renderCohortView()}
            </Box>
          </Grid>
    
          {/* Study Created Message (Conditional) */}
          {isStudyCreated()}
    
          {/* Cohort Card */}
          <Grid item xs={12} lg={7}>
            <Box p={2}>
              {renderCohortCard()}
            </Box>
          </Grid>
        </Grid>
      );
    }


function mapStateToProps (state) {
    if(state.authorization!==undefined)
    {
            return {
                token:state.authorization.token,
                studySettings: state.studySettings,
                selected_cohort: state.selected_cohort
            }
    }
}

// to send data from MainPanel component to the Store;
const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(Actions, dispatch),
    studyActions: bindActionCreators(StudyActions, dispatch),
    sampleActions: bindActionCreators(SampleActions, dispatch)
});




export default connect(mapStateToProps,mapDispatchToProps)(CohortSelect);